import React from "react";
import { withStyles } from "@material-ui/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Grid from "@material-ui/core/Grid";
import ReactMarkdown from "react-markdown";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import $ from "jquery";
import MonacoEditor from "react-monaco-editor";
import { MonacoDiffEditor } from "react-monaco-editor";
import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import Fab from "@material-ui/core/Fab";
import CodeIcon from "@material-ui/icons/Code";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { Link } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import Typography from "@material-ui/core/Typography";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import logoImg from "static/images/logow.png";
import SyntaxHighlighter from "react-syntax-highlighter";
import { tomorrowNightEighties } from "react-syntax-highlighter/dist/esm/styles/hljs";
import * as monaco from "monaco-editor";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MediaQuery from "react-responsive";

import NextIcon from "../static/images/next.png";
import PrevIcon from "../static/images/previous.png";
import NextIconDis from "../static/images/nextdis.png";
import PrevIconDis from "../static/images/previousdis.png";
import GobackIcon from "../static/images/goback.png";

import lessons_zh from "./languages/Contents_zh";
import { langDict, langAbbr, langCourses } from "./langConfig";

const isNumber = require("is-number");

// var langDict = ["中文", "English", "日本語", "Deutsch", "русский язык", "한국어"];
// var langAbbr = ["zh", "en", "ja", "de", "ru", "kr"];
var lessons = lessons_zh;

function getNumber(number) {
  if (isNumber(number)) return parseInt(number);
  return 0;
}

const styles = {
  topAppBar: {
    background: "#27211c",
  },
  bottomAppBar: {
    bottom: 0,
    top: "auto",
    background: "#27211c",
  },
  leftChapter: {
    background: "grey",
    textAlign: "left",
    color: "#c9c9c9",
    backgroundColor: "#08060d",
    paddingTop: "20px",
    paddingLeft: "15px",
    paddingRight: "15px",
    paddingBottom: "50px",
    overflowY: "auto",
  },
  leftChapter2: {
    background: "grey",
    textAlign: "left",
    overflowY: "auto",
  },
  rightChapter: {
    backgroundColor: "#110d16",
    overflowY: "auto",
  },
  appToolBar: {
    height: "50px",
    minHeight: "50px",
  },
  fileTabs: {
    color: "white",
  },
  codearea: {
    minHeight: "193px",
  },
  hintarea: {
    textAlign: "left",
  },
  editor: {
    textAlign: "left",
  },
  hint: {
    textAlign: "left",
  },
  list: {
    width: "300px",
    selected: {
      background: "#123456",
    },
  },
  fullList: {
    width: "auto",
  },
  paperAnchorLeft: {
    background: "#202020",
  },
  paperAnchorRight: {
    height: "calc(100% - 56px)",
    background: "#08060d",
    width: "99%",
  },
  fabLeft: {
    position: "absolute",
    bottom: "calc(2% + 56px)",
    right: "5%",
  },
  fabRights: {
    position: "absolute",
    bottom: "0.5%",
    width: "100%",
    textAlign: "left",
    minHeight: "48px",
  },
  fabRightl: {
    position: "relative",
    marginLeft: "2%",
  },
  fabRightr: {
    position: "absolute",
    left: "98%",
    transform: "translateX(-100%)",
  },
  botButton: {
    fontSize: "0.7rem",
    color: "#e0e0e0",
    border: "0.125rem solid #e0e0e0",
    borderRadius: "3.125rem",
    transition: "margin 0.3s ease",
  },
  botButtonDisabled: {
    border: "0",
  },
};

// const MOBILE_MAX_WIDTH = 1224;

const MOBILE_MAX_WIDTH = 1224;

const SHOW_ICON_MAX_WIDTH = 900;

class Chapter extends React.Component {
  // 代码
  codes = [];

  // 显示内容
  show = "";

  // 解决初次代码框不加载的问题
  firstLoad = true;

  // 解决检查代码按钮点击后在提示区出现黑框的问题
  cancleBlackbg = false;

  // 解决monaca-diff-editor的value改变问题
  valueChange = false;

  constructor(props) {
    super(props);
    // 解决多语言之间不同步更新造成的在跳转时出现白屏的问题
    lessons = lessons_zh;

    if (!props.match.params.lid) {
      this.state = {
        middleHeight: 150, // 窗口上下尺寸
        leftDrawerOpen: false, // 侧滑菜单
        rightDrawerOpen: false, // 侧滑菜单
        code: "", // 当前显示的代码
        currentLesson: 1, // 当前课程
        currentChapter: 1, // 当前章节
        currentFile: 0, // 当前文件
        type: lessons[0].chapters[0].type, //渲染类型
        answerCode: "", // 答案代码
        checkCode: "", // 输入的代码
        hintVisual: "none", // 提示可视性
        answerVisual: "hidden", // 答案可视性
        modalShow: false, // 提示模态框
        langMenu: null,
      };
    } else {
      this.state = {
        middleHeight: 150, // 窗口上下尺寸
        leftDrawerOpen: false, // 侧滑菜单
        rightDrawerOpen: false,
        code: "", // 当前显示的代码
        currentLesson: parseInt(props.match.params.lid), // 当前课程
        currentChapter: parseInt(props.match.params.cid), // 当前章节
        currentFile: 0, // 当前文件
        type: lessons[parseInt(props.match.params.lid) - 1].chapters[
          parseInt(props.match.params.cid) - 1
        ].type, //渲染类型
        answerCode: "", // 答案代码
        checkCode: "", // 输入的代码
        hintVisual: "none", // 提示可视性
        answerVisual: "hidden", // 答案可视性
        modalShow: false, // 提示模态框
        langMenu: null,
      };
    }

    // 语言参数接收
    const queryString = require("query-string");
    var parsed = queryString.parse(this.props.location.search);

    if (parsed.lang !== undefined) {
      if (parsed.lang === "zh") {
        localStorage.setItem("lang", 0);
      } else if (parsed.lang === "en") {
        localStorage.setItem("lang", 1);
      } else if (parsed.lang === "ja") {
        localStorage.setItem("lang", 2);
      }
    }

    // 编辑器高亮
    monaco.languages.register({ id: "log" });
    monaco.languages.setMonarchTokensProvider("log", {
      // Set defaultToken to invalid to see what you do not tokenize yet
      // defaultToken: 'invalid',

      keywords: [
        "abort",
        "assert",
        "break",
        "continue",
        "if",
        "else",
        "while",
        "loop",
        "let",
        "return",
        "import",
        "modules",
        "module",
        "public",
        "script",
      ],

      typeKeywords: ["bool", "u64", "address", "bytes", "struct", "resource"],

      operators: [
        "+",
        "-",
        "*",
        "%",
        "|",
        "&",
        "^",
        "&&",
        "||",
        "!",
        "!!",
        "==",
        "!=",
        "<",
        ">",
        "<=",
        ">=",
      ],

      // we include these common regular expressions
      symbols: /[=><!~?:&|+\-*\/\^%]+/,

      // C# style strings
      escapes:
        /\\(?:[abfnrtv\\"']|x[0-9A-Fa-f]{1,4}|u[0-9A-Fa-f]{4}|U[0-9A-Fa-f]{8})/,

      // The main tokenizer for our languages
      tokenizer: {
        root: [
          // identifiers and keywords
          [
            /[a-z_$][\w$]*/,
            {
              cases: {
                "@typeKeywords": "keyword",
                "@keywords": "keyword",
                "@default": "identifier",
              },
            },
          ],
          [/[A-Z][\w\$]*/, "type.identifier"], // to show class names nicely

          // whitespace
          { include: "@whitespace" },

          // delimiters and operators
          [/[{}()\[\]]/, "@brackets"],
          [/[<>](?!@symbols)/, "@brackets"],
          [/@symbols/, { cases: { "@operators": "operator", "@default": "" } }],

          // @ annotations.
          // As an example, we emit a debugging log message on these tokens.
          // Note: message are supressed during the first load -- change some lines to see them.
          [
            /@\s*[a-zA-Z_\$][\w\$]*/,
            { token: "annotation", log: "annotation token: $0" },
          ],

          // numbers
          [/\d*\.\d+([eE][\-+]?\d+)?/, "number.float"],
          [/0[xX][0-9a-fA-F]+/, "number.hex"],
          [/\d+/, "number"],

          // delimiter: after number because of .\d floats
          [/[;,.]/, "delimiter"],

          // strings
          [/"([^"\\]|\\.)*$/, "string.invalid"], // non-teminated string
          [/"/, { token: "string.quote", bracket: "@open", next: "@string" }],

          // characters
          [/'[^\\']'/, "string"],
          [/(')(@escapes)(')/, ["string", "string.escape", "string"]],
          [/'/, "string.invalid"],
        ],

        comment: [
          [/[^\/*]+/, "comment"],
          [/\/\*/, "comment", "@push"], // nested comment
          ["\\*/", "comment", "@pop"],
          [/[\/*]/, "comment"],
        ],

        string: [
          [/[^\\"]+/, "string"],
          [/@escapes/, "string.escape"],
          [/\\./, "string.escape.invalid"],
          [/"/, { token: "string.quote", bracket: "@close", next: "@pop" }],
        ],

        whitespace: [
          [/[ \t\r\n]+/, "white"],
          [/\/\*/, "comment", "@comment"],
          [/\/\/.*$/, "comment"],
        ],
      },
    });

    // 代码提示
    var suggestions = [
      {
        label: "abort",
        kind: monaco.languages.CompletionItemKind["Keyword"],
        insertText: "abort",
      },
      {
        label: "assert",
        kind: monaco.languages.CompletionItemKind["Keyword"],
        insertText: "assert",
      },
      {
        label: "break",
        kind: monaco.languages.CompletionItemKind["Keyword"],
        insertText: "break",
      },
      {
        label: "continue",
        kind: monaco.languages.CompletionItemKind["Keyword"],
        insertText: "continue",
      },
      {
        label: "if",
        kind: monaco.languages.CompletionItemKind["Keyword"],
        insertText: "if",
      },
      {
        label: "else",
        kind: monaco.languages.CompletionItemKind["Keyword"],
        insertText: "else",
      },
      {
        label: "while",
        kind: monaco.languages.CompletionItemKind["Keyword"],
        insertText: "while",
      },
      {
        label: "loop",
        kind: monaco.languages.CompletionItemKind["Keyword"],
        insertText: "loop",
      },
      {
        label: "let",
        kind: monaco.languages.CompletionItemKind["Keyword"],
        insertText: "let",
      },
      {
        label: "return",
        kind: monaco.languages.CompletionItemKind["Keyword"],
        insertText: "return",
      },
      {
        label: "import",
        kind: monaco.languages.CompletionItemKind["Keyword"],
        insertText: "import",
      },
      {
        label: "modules",
        kind: monaco.languages.CompletionItemKind["Keyword"],
        insertText: "modules",
      },
      {
        label: "module",
        kind: monaco.languages.CompletionItemKind["Keyword"],
        insertText: "module",
      },
      {
        label: "public",
        kind: monaco.languages.CompletionItemKind["Keyword"],
        insertText: "public",
      },
      {
        label: "script",
        kind: monaco.languages.CompletionItemKind["Keyword"],
        insertText: "script",
      },
      {
        label: "bool",
        kind: monaco.languages.CompletionItemKind["typeKeyword"],
        insertText: "bool",
      },
      {
        label: "u64",
        kind: monaco.languages.CompletionItemKind["typeKeyword"],
        insertText: "u64",
      },
      {
        label: "address",
        kind: monaco.languages.CompletionItemKind["typeKeyword"],
        insertText: "address",
      },
      {
        label: "bytes",
        kind: monaco.languages.CompletionItemKind["typeKeyword"],
        insertText: "bytes",
      },
      {
        label: "struct",
        kind: monaco.languages.CompletionItemKind["typeKeyword"],
        insertText: "struct",
      },
      {
        label: "resource",
        kind: monaco.languages.CompletionItemKind["typeKeyword"],
        insertText: "resource",
      },
    ];

    monaco.languages.registerCompletionItemProvider("log", {
      provideCompletionItems() {
        return {
          suggestions: suggestions,
        };
      },
      triggerCharacters: ["hint"], // 写触发提示的字符，可以有多个
    });
  }

  componentWillMount = () => {
    localStorage.setItem("lang", 1);
    // 加载lang默认参数
    if (!localStorage.getItem("lang")) {
      localStorage.setItem("lang", 0);
    } else {
      if (localStorage.getItem("lang") === "0") {
        lessons = lessons_zh;
      } else {
        let lessonsmodule = require("./languages/Contents_" +
          langAbbr[getNumber(localStorage.getItem("lang"))] +
          ".js");
        lessons = lessonsmodule.default;
      }
    }

    if (this.state.type === 0) {
      this.codes = JSON.parse(
        JSON.stringify(
          lessons[this.state.currentLesson - 1].chapters[
            this.state.currentChapter - 1
          ].codes
        )
      );
    }
    // 获取显示信息
    if (this.state.type === 0) {
      this.codes = JSON.parse(
        JSON.stringify(
          lessons[this.state.currentLesson - 1].chapters[
            this.state.currentChapter - 1
          ].codes
        )
      );
      this.setState({
        middleHeight: window.innerHeight,
        code: this.codes[this.state.currentFile].code,
        //仅第一个文件可以写，其他只读
        answerCode: this.codes[0].answer,
      });
    } else {
      this.show =
        lessons[this.state.currentLesson - 1].chapters[
          this.state.currentChapter - 1
        ].show();
      this.setState({
        middleHeight: window.innerHeight,
      });
    }
  };

  componentDidMount = () => {
    // 监听窗口大小改变
    window.addEventListener("resize", this.handleResize.bind(this));
  };

  componentWillUnmount = () => {
    //移除监听器，以防多个组件之间导致this的指向紊乱
    window.removeEventListener("resize", this.handleResize.bind(this));
  };

  handleResize = (e) => {
    this.setState({
      middleHeight: e.target.innerHeight,
    });
  };

  // 处理文件标签变换
  handleFileChange = (event, newValue) => {
    this.setState({
      currentFile: newValue,
      code: this.codes[newValue].code,
    });
  };

  // 打开/关闭侧滑菜单
  closeLeftDrawer = () => {
    this.setState({
      leftDrawerOpen: false,
    });
  };

  openLeftDrawer = () => {
    this.setState({
      leftDrawerOpen: true,
    });
  };

  closeRightDrawer = () => {
    this.setState({
      rightDrawerOpen: false,
    });
  };

  openRightDrawer = () => {
    this.setState({
      rightDrawerOpen: true,
    });
  };

  // 编辑器处理code变化
  onChange = (newValue, e) => {
    this.setState({
      code: newValue,
    });
    this.codes[this.state.currentFile].code = newValue;

    // 保存代码功能
    sessionStorage.setItem(
      `Code${this.state.currentLesson}-${this.state.currentChapter}`,
      newValue
    );
  };

  componentWillUpdate(nextProps, nextState) {
    // 回退重复跳出模态框
    if (this.state.modalShow) {
      this.setState({
        modalShow: false,
      });
    }

    // 确定是否需要加载新的资源文件
    if (
      parseInt(nextProps.match.params.lid) === this.state.currentLesson &&
      parseInt(nextProps.match.params.cid) === this.state.currentChapter
    ) {
      return;
    } else {
      if (
        lessons[parseInt(nextProps.match.params.lid) - 1].chapters[
          parseInt(nextProps.match.params.cid) - 1
        ].type === 0
      ) {
        this.codes = JSON.parse(
          JSON.stringify(
            lessons[parseInt(nextProps.match.params.lid) - 1].chapters[
              parseInt(nextProps.match.params.cid) - 1
            ].codes
          )
        );
      } else {
        this.show =
          lessons[parseInt(nextProps.match.params.lid) - 1].chapters[
            parseInt(nextProps.match.params.cid) - 1
          ].show();
      }
    }

    // 修改当前state信息
    if (
      lessons[parseInt(nextProps.match.params.lid) - 1].chapters[
        parseInt(nextProps.match.params.cid) - 1
      ].type === 0
    ) {
      this.valueChange = true;

      this.setState({
        code: sessionStorage.getItem(
          `Code${nextProps.match.params.lid}-${nextProps.match.params.cid}`
        )
          ? sessionStorage.getItem(
              `Code${nextProps.match.params.lid}-${nextProps.match.params.cid}`
            )
          : this.codes[0].code,
        currentLesson: parseInt(nextProps.match.params.lid),
        currentChapter: parseInt(nextProps.match.params.cid),
        currentFile: 0,
        type: 4,
        answerCode: this.codes[0].answer,
        checkCode: "", // 输入的代码
        hintVisual: "none", // 提示可视性
        answerVisual: "hidden", // 答案可视性
      });

      this.codes[0].code = sessionStorage.getItem(
        `Code${nextProps.match.params.lid}-${nextProps.match.params.cid}`
      )
        ? sessionStorage.getItem(
            `Code${nextProps.match.params.lid}-${nextProps.match.params.cid}`
          )
        : this.codes[0].code;
    } else if (
      lessons[parseInt(nextProps.match.params.lid) - 1].chapters[
        parseInt(nextProps.match.params.cid) - 1
      ].type === 1
    ) {
      this.setState({
        currentLesson: parseInt(nextProps.match.params.lid),
        currentChapter: parseInt(nextProps.match.params.cid),
        type: 1,

        checkCode: "", // 输入的代码
        hintVisual: "none", // 提示可视性
        answerVisual: "hidden", // 答案可视性
      });
    } else {
      this.setState({
        currentLesson: parseInt(nextProps.match.params.lid),
        currentChapter: parseInt(nextProps.match.params.cid),
        type: 2,

        checkCode: "", // 输入的代码
        hintVisual: "none", // 提示可视性
        answerVisual: "hidden", // 答案可视性
      });
    }
  }

  componentDidUpdate() {
    // 解决首次加载提示区的黑块问题
    if (this.cancleBlackbg) {
      if ($(".close-diff-review")) {
        $(".close-diff-review")[0].click();
      }
    }
    this.cancleBlackbg = false;

    if (this.firstLoad) {
      var myEvent = new Event("resize");
      window.dispatchEvent(myEvent);
      this.firstLoad = false;
    }

    // 重加载
    if (this.valueChange) {
      this.valueChange = false;
      this.setState({
        type: 0,
      });
    }
  }

  // 代码比对
  checkCodeWithAnswer(answer, code) {
    var a = answer
      .replace(/\/\/.*/g, "")
      .replace(/ +/g, "")
      .replace(/[  ]/g, "")
      .replace(/[\r\n\t]/g, "");
    var c = code
      .replace(/\/\/.*/g, "")
      .replace(/ +/g, "")
      .replace(/[  ]/g, "")
      .replace(/[\r\n\t]/g, "");

    return a === c;
  }

  // 检查代码
  checkCode = () => {
    // 将第一个文件代码推向monaca diff
    this.setState({
      hintVisual: "inline",
      checkCode: this.codes[0].code,
      // answerCode:this.codes[0].answer,
    });
    $(".modified-in-monaco-diff-editor .lines-content > .view-lines").css(
      "visibility",
      this.state.answerVisual
    );
    this.cancleBlackbg = true;

    // 正确的话跳向下一章
    if (this.checkCodeWithAnswer(this.state.answerCode, this.codes[0].code)) {
      this.setState({
        modalShow: true,
        rightDrawerOpen: false,
      });
    }
  };

  // 关闭模态框
  modalClose = () => {
    this.setState({
      modalShow: false,
    });
  };

  // 显示答案
  showAnswer = () => {
    if (this.state.answerVisual === "hidden") {
      this.setState({
        answerVisual: "visible",
      });
      $(".modified-in-monaco-diff-editor .lines-content > .view-lines").css(
        "visibility",
        "visible"
      );
    } else {
      this.setState({
        answerVisual: "hidden",
      });
      $(".modified-in-monaco-diff-editor .lines-content > .view-lines").css(
        "visibility",
        "hidden"
      );
    }
  };

  renderAnswer = () => {
    if (this.state.answerVisual === "hidden") {
      $(".modified-in-monaco-diff-editor .lines-content > .view-lines").css(
        "visibility",
        "hidden"
      );
    } else {
      $(".modified-in-monaco-diff-editor .lines-content > .view-lines").css(
        "visibility",
        "visible"
      );
    }
  };

  editorDidMount(editor, monaco) {}

  handleLangMenuClick = (event) => {
    this.setState({
      langMenu: event.currentTarget,
    });
  };

  closeLangMenu = (n) => {
    if (n === 0) {
      lessons = lessons_zh;
    } else if (n < langAbbr.length) {
      let lessonsmodule = require("./languages/Contents_" +
        langAbbr[n] +
        ".js");
      lessons = lessonsmodule.default;
    } else {
      n = localStorage.getItem("lang");
    }

    if (this.state.type !== 0) {
      this.show =
        lessons[this.state.currentLesson - 1].chapters[
          this.state.currentChapter - 1
        ].show();
    } else {
      this.codes = JSON.parse(
        JSON.stringify(
          lessons[this.state.currentLesson - 1].chapters[
            this.state.currentChapter - 1
          ].codes
        )
      );
      this.setState({
        code: this.codes[this.state.currentFile].code,
      });
    }

    this.setState({
      langMenu: null,
    });
    localStorage.setItem("lang", n);
  };

  //复制答案
  copyAnswer = () => {
    this.setState({
      code: this.state.answerCode,
      currentFile: 0,
    });
    this.codes[0].code = this.state.answerCode;
  };

  render() {
    // 解决改变问题
    if (this.valueChange) {
      return <div>正在加载。。。</div>;
    }

    var leftArea, rightArea;

    if (this.state.type === 0) {
      // 编辑器选项
      const editorOptions = {
        selectOnLineNumbers: true,
        fontSize: "14px",
        readOnly: this.state.currentFile,
        minimap: { enabled: false },
      };

      const hintOptions = {
        fontSize: "14px",
        readOnly: true,
        renderSideBySide: false,
        lineNumbers: "off",
        renderIndicators: false,
      };

      //渲染文件名
      var filetabs = this.codes.map((item, index) => (
        <Tab label={item.title} key={index} />
      ));

      var leftMarkdownComponent = (
        <ReactMarkdown
          source={
            lessons[this.state.currentLesson - 1].chapters[
              this.state.currentChapter - 1
            ].instruction
          }
          // renderers 怎么用
          renderers={{
            // inlineCode: InlineCoder,
            code: Coder,
            blockquote: Blockr,
          }}
          escapeHtml={false}
        />
      );
      leftArea = leftMarkdownComponent;

      var rightCodeComponent = (
        <div
          className={this.props.classes.codearea}
          id="code"
          style={{ overflow: "hidden" }}
        >
          <Tabs
            value={this.state.currentFile}
            onChange={this.handleFileChange}
            className={this.props.classes.fileTabs}
            variant="scrollable"
          >
            {filetabs}
          </Tabs>

          <div
            className={this.props.classes.editor}
            style={{ overflow: "hidden" }}
          >
            <MonacoEditor
              height={
                (this.state.middleHeight -
                  (this.state.rightDrawerOpen &&
                  window.innerWidth < MOBILE_MAX_WIDTH
                    ? 56
                    : 112) -
                  96) *
                  0.55 >
                40
                  ? (this.state.middleHeight -
                      (this.state.rightDrawerOpen &&
                      window.innerWidth < MOBILE_MAX_WIDTH
                        ? 56
                        : 112) -
                      96) *
                    0.55
                  : 40
              }
              width={$("#code").width()}
              theme="vs-dark"
              language="log"
              value={this.state.code}
              options={editorOptions}
              onChange={this.onChange}
              editorDidMount={this.editorDidMount}
            />
          </div>

          <div
            className={this.props.classes.hintarea}
            style={{ overflow: "hidden" }}
          >
            <Tabs
              value={0}
              className={this.props.classes.fileTabs}
              variant="scrollable"
            >
              <Tab label={lessons[0].local.hint} />
            </Tabs>
            <div
              id="hint"
              style={{ display: this.state.hintVisual, overflow: "hidden" }}
            >
              <MonacoDiffEditor
                height={
                  (this.state.middleHeight -
                    (this.state.rightDrawerOpen &&
                    window.innerWidth < MOBILE_MAX_WIDTH
                      ? 56
                      : 112) -
                    96) *
                    0.45 >
                  40
                    ? (this.state.middleHeight -
                        (this.state.rightDrawerOpen &&
                        window.innerWidth < MOBILE_MAX_WIDTH
                          ? 56
                          : 112) -
                        96) *
                      0.45
                    : 40
                }
                width={$("#code").width()}
                original={this.state.checkCode.replace(/\/\/.*/g, "")}
                value={this.state.answerCode.replace(/\/\/.*/g, "")}
                language="log"
                onChange={this.onChange}
                options={hintOptions}
                editorDidMount={this.editorDidMount}
              />
            </div>
          </div>
        </div>
      );

      rightArea = rightCodeComponent;
    } else if (this.state.type === 1) {
      leftMarkdownComponent = (
        <ReactMarkdown
          source={
            lessons[this.state.currentLesson - 1].chapters[
              this.state.currentChapter - 1
            ].instruction
          }
        />
      );
      leftArea = leftMarkdownComponent;
      rightArea = this.show;
    } else {
      rightArea = this.show;
    }

    // 侧滑菜单
    const sideList = () => (
      <div
        className={this.props.classes.list}
        role="presentation"
        onClick={this.closeLeftDrawer}
      >
        <ListItem>
          <ListItemText
            primary={
              <h3>{lessons[this.state.currentLesson - 1].lessonserial}</h3>
            }
            style={{ color: "white" }}
          />
        </ListItem>

        <Divider
          style={{
            backgroundColor: "#7d7d7d",
            height: "3px",
            marginLeft: "8px",
            marginRight: "8px",
          }}
        />

        <List>
          {lessons[this.state.currentLesson - 1].chapters.map((item, index) => (
            <Link
              to={`/lesson/${this.state.currentLesson}/chapter/${index + 1}`}
              key={index}
            >
              <ListItem
                style={
                  this.state.currentChapter - 1 !== index
                    ? {}
                    : {
                        backgroundColor: "rgba(220, 220, 220, 0.14)",
                      }
                }
                button
                key={index}
                selected={this.state.currentChapter - 1 === index}
              >
                <ListItemText primary={"● " + item.title} />
              </ListItem>
            </Link>
          ))}
        </List>
      </div>
    );

    const leftMenuButton = () => (
      <React.Fragment>
        <Grid item sm={1} style={{ textAlign: "left" }}>
          <Button onClick={this.openLeftDrawer} style={{ width: "25px" }}>
            <img
              src={require("static/images/menu.png")}
              style={{ height: "25px" }}
              alt="menu"
            ></img>
          </Button>
        </Grid>
        <Grid item sm={1}></Grid>
      </React.Fragment>
    );

    const checkCodeButtons = () => (
      <React.Fragment>
        <Grid item sm={2}>
          {this.state.type === 0 ? (
            <Button
              className={this.props.classes.botButton}
              onClick={this.showAnswer}
              style={{ display: this.state.hintVisual }}
            >
              {this.state.answerVisual === "hidden"
                ? lessons[0].local.showAnswer
                : lessons[0].local.hideAnswer}
            </Button>
          ) : (
            ""
          )}
        </Grid>
        <Grid item sm={1}></Grid>
        <Grid item sm={2}>
          {this.state.type === 0 ? (
            <Button
              className={this.props.classes.botButton}
              onClick={this.checkCode}
            >
              {lessons[0].local.checkcode}
            </Button>
          ) : (
            ""
          )}
        </Grid>
      </React.Fragment>
    );

    const rightPageButtons = () => (
      <React.Fragment>
        <Grid item sm={5} style={{ textAlign: "right" }}>
          {this.state.currentChapter === 1 ? (
            <Button
              classes={{
                root: this.props.classes.botButton,
                disabled: this.props.classes.botButtonDisabled,
              }}
              disabled
            >
              {document.documentElement.clientWidth < SHOW_ICON_MAX_WIDTH ? (
                <img src={PrevIconDis} style={{ height: "20px" }}></img>
              ) : (
                lessons[0].local.previous
              )}
            </Button>
          ) : (
            <Link
              to={`/lesson/${this.state.currentLesson}/chapter/${
                this.state.currentChapter - 1
              }`}
            >
              <Button
                classes={{
                  root: this.props.classes.botButton,
                  disabled: this.props.classes.botButtonDisabled,
                }}
              >
                {document.documentElement.clientWidth < SHOW_ICON_MAX_WIDTH ? (
                  <img src={PrevIcon} style={{ height: "20px" }}></img>
                ) : (
                  lessons[0].local.previous
                )}
              </Button>
            </Link>
          )}
          <span style={{ color: "white" }}>
            &nbsp;&nbsp; {this.state.currentChapter} /{" "}
            {lessons[this.state.currentLesson - 1].total} &nbsp;&nbsp;
          </span>
          {this.state.currentChapter ===
          lessons[this.state.currentLesson - 1].total ? (
            <Button
              classes={{
                root: this.props.classes.botButton,
                disabled: this.props.classes.botButtonDisabled,
              }}
              disabled
            >
              {document.documentElement.clientWidth < SHOW_ICON_MAX_WIDTH ? (
                <img src={NextIconDis} style={{ height: "20px" }}></img>
              ) : (
                lessons[0].local.next
              )}
            </Button>
          ) : (
            <Link
              to={`/lesson/${this.state.currentLesson}/chapter/${
                this.state.currentChapter + 1
              }`}
            >
              <Button
                classes={{
                  root: this.props.classes.botButton,
                  disabled: this.props.classes.botButtonDisabled,
                }}
              >
                {document.documentElement.clientWidth < SHOW_ICON_MAX_WIDTH ? (
                  <img src={NextIcon} style={{ height: "20px" }}></img>
                ) : (
                  lessons[0].local.next
                )}
              </Button>
            </Link>
          )}
        </Grid>
      </React.Fragment>
    );

    this.renderAnswer();

    return (
      <React.Fragment>
        <AppBar
          position="relative"
          color="primary"
          className={this.props.classes.topAppBar}
        >
          <Toolbar style={{ minHeight: "56px", paddingLeft: "0" }}>
            <a href={lessons[0].info.indexpage}>
              <img src={logoImg} style={{ height: "40px" }} alt="logo"></img>
            </a>
            <div>
              {/* <Link to="/" style={{ color: "white" }}>
                {document.documentElement.clientWidth < SHOW_ICON_MAX_WIDTH ? (
                  <img
                    src={GobackIcon}
                    style={{ height: "36px" }}
                    title={lessons[0].info.goback}
                  ></img>
                ) : (
                  lessons[0].info.goback
                )}
              </Link> */}
            </div>

            {/* <Button
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={this.handleLangMenuClick}
              style={{
                position: "absolute",
                left: "100%",
                transform: "translate(-100%, 0%)",
              }}
            >
              <span style={{ color: "white" }}>
                {langAbbr[localStorage.getItem("lang")]}
              </span>
              <span style={{ color: "white" }}>&nbsp;▼</span>
            </Button> */}
            <Menu
              id="simple-menu"
              anchorEl={this.state.langMenu}
              keepMounted
              open={Boolean(this.state.langMenu)}
              onClose={this.closeLangMenu}
            >
              {langDict.slice(1).map((item, index) => {
                if (langCourses[index] >= this.state.currentLesson) {
                  return (
                    <MenuItem onClick={this.closeLangMenu.bind(this, index)}>
                      {item}({langAbbr[index].toUpperCase()})
                    </MenuItem>
                  );
                }
              })}
              {/* <Divider light />
              <a
                href="https://github.com/ChainCastle/Multilingual-MoveCastle"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "black" }}
              >
                <MenuItem onClick={this.closeLangMenu}>Contribution</MenuItem>
              </a> */}
            </Menu>
          </Toolbar>
        </AppBar>
        <div>
          <Drawer
            open={this.state.leftDrawerOpen}
            onClose={this.closeLeftDrawer}
            classes={{
              paper: this.props.classes.paperAnchorLeft,
            }}
          >
            {sideList()}
          </Drawer>

          <Dialog
            aria-labelledby="customized-dialog-title"
            open={this.state.modalShow}
          >
            <MuiDialogTitle id="customized-dialog-title">
              {this.state.currentChapter !==
              lessons[this.state.currentLesson - 1].total
                ? lessons[0].local.contitle[0]
                : this.state.currentLesson !== lessons.length
                ? lessons[0].local.contitle[1]
                : lessons[0].local.contitle[2]}
            </MuiDialogTitle>
            <MuiDialogContent dividers>
              <Typography gutterBottom>
                {this.state.currentChapter !==
                lessons[this.state.currentLesson - 1].total
                  ? lessons[0].local.concontent[0]
                  : this.state.currentLesson !== lessons.length
                  ? lessons[0].local.concontent[1]
                  : lessons[0].local.concontent[2]}
              </Typography>
            </MuiDialogContent>
            <MuiDialogActions>
              {this.state.currentChapter !==
              lessons[this.state.currentLesson - 1].total ? (
                <Link
                  to={`/lesson/${this.state.currentLesson}/chapter/${
                    this.state.currentChapter + 1
                  }`}
                >
                  <Button onClick={this.modalClose} color="primary">
                    {lessons[0].local.concontinue[0]}
                  </Button>
                </Link>
              ) : (
                <React.Fragment>
                  <Link
                    to={`/lesson/${this.state.currentLesson}/chapter/${this.state.currentChapter}`}
                  >
                    <Button onClick={this.modalClose} color="primary">
                      {lessons[0].local.shut}
                    </Button>
                  </Link>

                  <Link to="/">
                    <Button onClick={this.modalClose} color="primary">
                      {lessons[0].local.concontinue[1]}
                    </Button>
                  </Link>

                  {this.state.currentLesson === lessons.length ? (
                    <a href={process.env.REACT_APP_INDEXPAGE} target="_blank">
                      <Button onClick={this.modalClose} color="primary">
                        {lessons[0].local.concontinue[2]}
                      </Button>
                    </a>
                  ) : (
                    <Link
                      to={`/lesson/${this.state.currentLesson + 1}/chapter/1`}
                    >
                      <Button onClick={this.modalClose} color="primary">
                        {lessons[0].local.concontinue[3]}
                      </Button>
                    </Link>
                  )}
                </React.Fragment>
              )}
            </MuiDialogActions>
          </Dialog>

          <Grid
            direction="row"
            container
            style={{ display: this.state.type === 2 ? "none" : "" }}
          >
            <MediaQuery maxWidth={MOBILE_MAX_WIDTH}>
              <Grid
                item
                xs={12}
                sm={12}
                className={this.props.classes.leftChapter}
                style={{ height: this.state.middleHeight - 112 }}
                id="leftMark"
              >
                {leftArea}
              </Grid>
              <Fab
                color="primary"
                variant="extended"
                className={this.props.classes.fabLeft}
                onClick={this.openRightDrawer}
              >
                <CodeIcon />
                &nbsp;{lessons[0].info.editor}
              </Fab>
              <Drawer
                variant="persistent"
                anchor="right"
                open={this.state.rightDrawerOpen}
                onClose={this.closeRightDrawer}
                classes={{
                  paper: this.props.classes.paperAnchorRight,
                }}
              >
                {rightArea}
                <div className={this.props.classes.fabRights}>
                  {lessons[this.state.currentLesson - 1].chapters[
                    this.state.currentChapter - 1
                  ].type === 0 ? (
                    <Fab
                      className={this.props.classes.fabRightl}
                      color="default"
                      variant="extended"
                      onClick={this.copyAnswer}
                      style={{
                        visibility:
                          this.state.answerVisual === "hidden"
                            ? "hidden"
                            : "visible",
                      }}
                    >
                      {lessons[0].info.copyAnswer}
                    </Fab>
                  ) : (
                    ""
                  )}
                  <Fab
                    color="secondary"
                    variant="extended"
                    className={this.props.classes.fabRightr}
                    onClick={this.closeRightDrawer}
                  >
                    <ChevronLeftIcon />
                    {lessons[0].info.lesson}
                  </Fab>
                </div>
              </Drawer>
            </MediaQuery>
            <MediaQuery minWidth={MOBILE_MAX_WIDTH + 1}>
              <Grid
                item
                xs={12}
                sm={6}
                className={this.props.classes.leftChapter}
                style={{ height: this.state.middleHeight - 112 }}
                id="leftMark"
              >
                {leftArea}
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                className={this.props.classes.rightChapter}
                style={{ height: this.state.middleHeight - 112 }}
              >
                {rightArea}
              </Grid>
            </MediaQuery>
          </Grid>
          <Grid
            container
            direction="column"
            style={{ display: this.state.type === 2 ? "" : "none" }}
          >
            <Grid
              item
              xs={12}
              sm={12}
              className={this.props.classes.leftChapter2}
              style={{ height: this.state.middleHeight - 112 }}
            >
              {rightArea}
            </Grid>
          </Grid>
        </div>
        <AppBar
          position="fixed"
          color="primary"
          className={this.props.classes.bottomAppBar}
        >
          <Toolbar style={{ minHeight: "56px" }}>
            <Grid container justify="space-between" alignItems="flex-end">
              <MediaQuery maxWidth={MOBILE_MAX_WIDTH}>
                {!this.state.rightDrawerOpen && leftMenuButton()}
                {this.state.rightDrawerOpen && checkCodeButtons()}
                {!this.state.rightDrawerOpen && rightPageButtons()}
              </MediaQuery>
              <MediaQuery minWidth={MOBILE_MAX_WIDTH + 1}>
                {leftMenuButton()}
                {checkCodeButtons()}
                {rightPageButtons()}
              </MediaQuery>
            </Grid>
          </Toolbar>
        </AppBar>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(Chapter);

class Coder extends React.Component {
  render() {
    // var codes = this.props.value;
    // codes = codes.replace("\n", "<br />").replace(" ", "&nbsp;").replace("\t", "&#9;")
    // return <pre><div style={{overflowX:"auto", fontFamily:"source-code-pro, Menlo, Monaco, Consolas, Courier New, monospace"}}>{this.props.value}</div></pre>
    return (
      <SyntaxHighlighter
        language="javascript"
        style={tomorrowNightEighties}
        showLineNumbers
      >
        {this.props.value}
      </SyntaxHighlighter>
    );
  }
}

class Blockr extends React.Component {
  render() {
    return (
      <blockquote
        style={{
          background: "#2d2d2d",
          marginLeft: "0",
          marginRight: "0",
          paddingLeft: "16px",
          paddingRight: "6px",
          paddingTop: "15px",
          paddingBottom: "15px",
          borderLeft: "8px solid #888888",
        }}
      >
        {this.props.children[0].props.children[0].props.children}
      </blockquote>
    );
  }
}

// class InlineCoder extends React.Component{
//   render(){
//     return (
//       <div style={{borderRadius: "5px", background:"#777777"}}>
//     <SyntaxHighlighter
//       language="javascript"
//       style={tomorrowNightEighties}
//       useInlineStyles="true"
//     >
//       {this.props.value}
//     </SyntaxHighlighter>
//     </div>
//     )
//   }
// }
